export default {
  cn: {
    userModel: {
      userInfo: '用户信息',
      loginId: '登录账号',
      loginName: '用户名称',
      userPwd: '用户密码',
      isEnable: '是否启用',
      yes: '是',
      no: '否',
      setRole: '设置角色',
      existingRoleList: '已有角色列表',
      selectedRoleList: '已选中的角色列表',
      saveBtn: '保存',
      success: '保存成功',
      pleaseEnter: '请输入',
      pleaseSelect: '请选择',
      noEdit: '尚未修改，无须保存',
      errTips: '请正确填写信息',
      btnBack: '返回',
    }
  },
  hk: {
    userModel: {
      userInfo: '用戶信息',
      loginId: '登錄賬號',
      loginName: '用戶名稱',
      userPwd: '用戶密碼',
      isEnable: '是否啟用',
      yes: '是',
      no: '否',
      setRole: '設置角色',
      existingRoleList: '已有角色列表',
      selectedRoleList: '已選中的角色列表',
      saveBtn: '保存',
      success: '保存成功',
      pleaseEnter: '請輸入',
      pleaseSelect: '請選擇', 
      noEdit: '尚未修改，無須保存',
      errTips: '請正確填寫信息',
      btnBack: '返回',
    }
  },
  en: {
    userModel: {
      userInfo: 'User Info',
      loginId: 'Login ID',
      loginName: 'User Name',
      userPwd: 'Password',
      isEnable: 'Enabled',
      yes: 'Yes',
      no: 'No',
      setRole: 'Set Role',
      existingRoleList: 'Existing Role List',
      selectedRoleList: 'Selected Role List',
      saveBtn: 'SAVE',
      success: 'Successful',
      pleaseEnter: 'Please Enter',
      pleaseSelect: 'Please Select',
      noEdit: 'Not yet modified, no need to save',
      errTips: 'Please fill in the information correctly',
      btnBack: 'Back',
    }
  },
}


// WEBPACK FOOTER //
// ./src/language/userModel.js